import "./App.css";
import { React, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Footers from "./components/landing/footer/Footer";
import Term from "./components/landing/term/Term";
import Question from "./components/landing/question/Question";
import Privacy from "./components/landing/privacy/Privacy";
import Landing from "./pages/Landing";

function App() {
  useEffect(() => {
    if (window.location.pathname !== "/landing") {
      window.location.replace("/landing");
    }
  }, []);
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/landing"
            element={
              <>
              <Landing />
              </>
            }
          />
          <Route path="/privacy" element={<Privacy />}></Route>
          <Route path="/faq" element={<Question />}></Route>
          <Route path="/term" element={<Term />}></Route>
        </Routes>
        <Footers />
        <ToastContainer />
      </BrowserRouter>
    </>
  );
}

export default App;
